module.exports = __webpack_public_path__ + "static/media/add book.9fb476cf.svg";